import { isDomain } from './validate'

const validatePassword = (rule: any, value: string, callback: Function) => {
  if (value.length < 6) {
    callback(new Error('The password can not be less than 6 digits'))
  } else {
    callback()
  }
}

const validatePassword2 = (rule: any, value: string, callback: Function) => {
  if (!value) {
    callback()
  } else {
    if (value.length < 6) {
      callback(new Error('The password can not be less than 6 digits'))
    } else {
      callback()
    }
  }
}

const validateDomain = (rule: any, value: string, callback: Function) => {
  if (!value) {
    callback()
  } else {
    if (!isDomain(value)) {
      callback(new Error('Domain name format error!'))
    } else {
      callback()
    }
  }
}
const validateDomainName = (rule, value, callback) => {
  let reg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/
  if (!reg.test(value)) {
    callback(new Error('Domain name format error!'))
  } else {
    callback()
  }
}

export const adminRules = {
  username: [
    { required: true, message: 'Please enter the Username', trigger: 'blur' }
  ],
  password: [
    {
      required: true,
      message: 'Please enter the Password',
      validator: validatePassword,
      trigger: 'blur'
    }
  ],
  email: [
    {
      required: true,
      message: 'Please enter your email address',
      trigger: 'blur'
    },
    {
      type: 'email',
      message: 'Please enter the correct email address',
      trigger: ['blur', 'change']
    }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ],
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ],
  manager_type: [
    { required: true, message: 'Please Select Manager Type', trigger: 'blur' }
  ],
  ip_address: [
    { required: true, message: 'Please enter the IP', trigger: 'blur' }
  ]
}

export const setAdminRules = {
  username: [
    { required: true, message: 'Please enter the Username', trigger: 'blur' }
  ],
  password: [{ validator: validatePassword2, trigger: 'blur' }],
  email: [
    {
      required: true,
      message: 'Please enter your email address',
      trigger: 'blur'
    },
    {
      type: 'email',
      message: 'Please enter the correct email address',
      trigger: ['blur', 'change']
    }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ],
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ],
  manager_type: [
    { required: true, message: 'Please Select Manager Type', trigger: 'blur' }
  ]
}

export const secretRules = {
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ],
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ]
}

export const productAccountBasicRules = {
  account_name: [
    {
      required: true,
      message: 'Please enter the Account Name',
      trigger: 'blur'
    }
  ],
  account_no: [
    { required: true, message: 'Please enter the Account No', trigger: 'blur' }
  ],
  account_type: [
    { required: true, message: 'Please select Account Type', trigger: 'blur' }
  ],
  status: [
    { required: true, message: 'Please select status', trigger: 'blur' }
  ],
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ]
}

export const merchantBasicRules = {
  name: [
    {
      required: true,
      message: 'Please enter the Merchant Name',
      trigger: 'blur'
    }
  ],
  email: [
    {
      required: true,
      message: 'Please enter your email address',
      trigger: 'blur'
    },
    {
      type: 'email',
      message: 'Please enter the correct email address',
      trigger: ['blur', 'change']
    }
  ],
  password: [
    { required: true, message: 'Please set your password', trigger: 'blur' }
  ],
  pin: [
    {
      required: true,
      message: 'Please set the withdrawal password',
      trigger: 'blur'
    }
  ],
  status: [
    { required: true, message: 'Please select status', trigger: 'blur' }
  ],
  // notify_url: [{ validator: validateDomain, trigger: 'blur' }],
  // return_url: [{ validator: validateDomain, trigger: 'blur' }],
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ],
  key: [
    { required: true, message: 'Please input Merchant Key', trigger: 'blur' }
  ],
  phone: [
    { required: true, message: 'Please enter the Phone', trigger: 'blur' }
  ]
}

export const merchantProductRules = {
  currency: [
    { required: true, message: 'Please select Currency', trigger: 'blur' }
  ],
  product_type: [
    { required: true, message: 'Please select product type', trigger: 'blur' }
  ],
  billing_type: [
    { required: true, message: 'Please select settlement limit', trigger: 'change' }
  ],
  fixed_fee: [
    { required: true, message: 'Please select fee', trigger: 'blur' }
  ],
  min_amount: [
    { required: true, message: 'Please select min amount', trigger: 'blur' }
  ],
  product_name: [
    { required: true, message: 'Please select Product', trigger: 'blur' }
  ]
}

export const merchantAgentProductRules = {
  currency: [
    { required: true, message: 'Please select Currency', trigger: 'blur' }
  ],
  product_type: [
    { required: true, message: 'Please select product type', trigger: 'blur' }
  ],
  product_name: [
    { required: true, message: 'Please select Product', trigger: 'blur' }
  ]
}

export const descendantsRules = {
  start_time: [
    { required: true, message: 'Please select Start time', trigger: 'blur' }
  ],
  end_time: [
    { required: true, message: 'Please select End time', trigger: 'blur' }
  ]
}

export const bankAccountRules = {
  currency: [
    { required: true, message: 'Please select Currency', trigger: 'blur' }
  ],
  status: [
    { required: true, message: 'Please select status', trigger: 'blur' }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ],
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ]
}

export const merchantBananceRules = {
  currency: [
    { required: true, message: 'Please select Currency', trigger: 'blur' }
  ],
  operation_type: [
    {
      required: true,
      message: 'Please select Operation Type',
      trigger: 'change'
    }
  ],
  amount: [{ required: true, message: 'Please input amount', trigger: 'blur' }],
  remarks: [
    { required: true, message: 'Please input remarks', trigger: 'blur' }
  ],
  in_or_out: [
    { required: true, message: 'Please select Direction', trigger: 'blur' }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ],
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ]
}

export const setOrderStatusRules = {
  status: [
    { required: true, message: 'Please select status', trigger: 'blur' }
  ],
  remarks: [
    { required: true, message: 'Please input remarks', trigger: 'blur' }
  ],
  product_sub_code: [
    { required: true, message: 'Please select product sub code', trigger: 'blur' }
  ],
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ]
}

export const testRules = {
  merchant: [
    { required: true, message: 'Please select merchant', trigger: 'blur' }
  ],
  product: [
    { required: true, message: 'Please select product', trigger: 'blur' }
  ],
  product_account: [
    {
      required: true,
      message: 'Please select Product account',
      trigger: 'blur'
    }
  ],
  amount: [
    { required: true, message: 'Please enter the amount', trigger: 'blur' }
  ]
}

export const approvalRules = {
  product: [
    { required: true, message: 'Please select product', trigger: 'blur' }
  ],
  product_account: [
    {
      required: true,
      message: 'Please select Product account',
      trigger: 'blur'
    }
  ],
  product_accounts: [
    {
      required: true,
      message: 'Please select Product account',
      trigger: 'blur'
    }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ]
}

export const setAuditStatusRules = {
  status: [
    { required: true, message: 'Please select status', trigger: 'blur' }
  ],
  reason: [
    { required: true, message: 'Please input remarks', trigger: 'blur' }
  ],
  ordernumber: [
    { required: true, message: 'Please select ordernumber', trigger: 'change' }
  ],
  merchant_no: [
    { required: true, message: 'Please input merchant no', trigger: 'blur' }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ]
}

export const settingRules = {
  manage_domain: [
    { required: true, validator: validateDomain, trigger: 'blur' }
  ],
  merchant_domain: [
    { required: true, validator: validateDomain, trigger: 'blur' }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ]
}

export const enterpriseRules = {
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ],
  test_merchant_no: [
    { required: true, message: 'Please input Merchant No', trigger: 'blur' }
  ]
}

export const otherRules = {
  description: [
    { required: true, message: 'Please input description', trigger: 'blur' }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ]
}

export const bulkChanges = {
  status: [
    { required: true, message: 'Please select status', trigger: 'blur' }
  ],
  remarks: [
    { required: true, message: 'Please input remarks', trigger: 'blur' }
  ],
  description: [
    { required: true, message: 'Please input remarks', trigger: 'blur' }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ]
}

export const addWalletRules = {
  currency: [
    { required: true, message: 'Please select Currency', trigger: 'change' }
  ],
  account_type: [
    {
      required: true,
      message: 'Please select AccoexchangeRateRulesunt Type',
      trigger: 'change'
    }
  ],
  name: [{ required: true, message: 'Please enter the Name', trigger: 'blur' }],
  address: [
    { required: true, message: 'Please enter the Address', trigger: 'blur' }
  ],
  private_key: [
    { required: true, message: 'Please input Private Key', trigger: 'blur' }
  ]
}

export const exchangeRateRules = {
  base_currency: [
    { required: true, message: 'Please select Base Currency', trigger: 'blur' }
  ],
  quote_currency: [
    { required: true, message: 'Please input Quote Currency', trigger: 'blur' }
  ],
  mode: [{ required: true, message: 'Please select Mode', trigger: 'blur' }],
  bid: [{ required: true, message: 'Please input Bid', trigger: 'blur' }],
  ask: [{ required: true, message: 'Please input Ask', trigger: 'blur' }]
}

export const newSettingRules = {
  checkout_counter_domain: [
    {
      required: true,
      message: 'Please enter the correct domain name format',
      trigger: 'blur'
    },
    { validator: validateDomainName }
  ]
}

export const applicationRules = {
  name: [
    {
      required: true,
      message: 'Please enter the application Name',
      trigger: 'blur'
    }
  ],
  enterprise_type: [
    {
      required: true,
      message: 'Please select enterprise type',
      trigger: 'blur'
    }
  ],
  status: [
    { required: true, message: 'Please select status', trigger: 'blur' }
  ],
  can_active: [
    { required: true, message: 'Please select active status', trigger: 'blur' }
  ]
}

export const accountGroupRules = {
  name: [
    {
      required: true,
      message: 'Please enter the account group name',
      trigger: 'blur'
    }
  ],
  status: [
    { required: true, message: 'Please select status', trigger: 'blur' }
  ],
  product_account: [
    {
      required: true,
      message: 'Please select product account',
      trigger: 'blur'
    }
  ]
}

export const addressRules = {
  collect_wallet: [
    {
      required: true,
      message: 'Please enter the wallet address',
      trigger: 'blur'
    }
  ],
  google_code: [
    { required: true, message: 'Please input Google Code', trigger: 'blur' }
  ]
}

export const pledgeRules = {
  pledge_type: [
    {
      required: true,
      message: 'Please select pledge type',
      trigger: 'change'
    }
  ],
  address: [
    {
      required: true,
      message: 'Please input address',
      trigger: 'blur'
    }
  ],
  id: [
    {
      required: true,
      message: 'Please select product',
      trigger: 'change'
    }
  ],
  product_account: [
    {
      required: true,
      message: 'Please select product account',
      trigger: 'change'
    }
  ],
  resource: [
    {
      required: true,
      message: 'Please select resource',
      trigger: 'change'
    }
  ],
  frozen_balance: [
    { required: true, message: 'Please input frozen balance', trigger: 'change' }
  ]
}

export const checkoutCounter = {
  path: [
    {
      required: true,
      message: 'Please enter the path',
      trigger: 'blur'
    }
  ]
}
